'use client'

import { WhiteLabelAssets } from '../../white-label-assets'
import { LoginCard } from '../login-card'
import { useThemeStore } from '@/lib/stores/theme-store'

interface CenteredLayoutProps {
  children: React.ReactNode
  titleShowcase: string
  brandName: string
  videoUrl?: string
}

export function CenteredLayout({ children, titleShowcase, brandName, videoUrl }: CenteredLayoutProps) {
  const { currentTheme } = useThemeStore()
  const objectPosition = currentTheme?.login?.layout?.body?.imagePosition || 'center'

  return (
    <div className="h-full relative rounded-xl">
      {/* Background with white-label image - fixo */}
      <div className="absolute inset-0 rounded-xl overflow-hidden m-2">
        <WhiteLabelAssets
          type="background"
          className="absolute inset-0 scale-100 origin-center w-full h-full"
          priority={true}
          alt="Login background"
          objectPosition={objectPosition}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background/20 to-transparent" />
      </div>

      {/* Container com scroll */}
      <div className="h-full overflow-y-auto">
        <div className="min-h-full flex items-center justify-center py-4">
          {/* Login Card - Centralizado */}
          <div className="container flex justify-center relative z-10">
            <LoginCard titleShowcase={titleShowcase} brandName={brandName} videoUrl={videoUrl}>
              {children}
            </LoginCard>
          </div>
        </div>
      </div>
    </div>
  )
}

